/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { contacts_ContactAuditResponse } from '../models/contacts_ContactAuditResponse';
import type { contacts_ContactCountsResponse } from '../models/contacts_ContactCountsResponse';
import type { contacts_ContactListResponse } from '../models/contacts_ContactListResponse';
import type { contacts_ContactLoginStatusResponse } from '../models/contacts_ContactLoginStatusResponse';
import type { contacts_CreateContactRequest } from '../models/contacts_CreateContactRequest';
import type { contacts_ExportContactsVCardRequest } from '../models/contacts_ExportContactsVCardRequest';
import type { contacts_LinkContactLoginResponse } from '../models/contacts_LinkContactLoginResponse';
import type { contacts_ProvisionContactLoginResponse } from '../models/contacts_ProvisionContactLoginResponse';
import type { contacts_ReissueContactLoginResponse } from '../models/contacts_ReissueContactLoginResponse';
import type { contacts_RevokeContactLoginResponse } from '../models/contacts_RevokeContactLoginResponse';
import type { contacts_UpdateContactCustomerScoreRequest } from '../models/contacts_UpdateContactCustomerScoreRequest';
import type { contacts_UpdateContactRequest } from '../models/contacts_UpdateContactRequest';
import type { contacts_UpdateContactStatusRequest } from '../models/contacts_UpdateContactStatusRequest';
import type { models_Contact } from '../models/models_Contact';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactsService {
    /**
     * List contacts with pagination, filtering, search, and sorting
     * Get a paginated list of contacts with optional filtering by status, search, and sorting
     * @param limit Maximum number of items to return
     * @param offset Number of items to skip
     * @param status Comma-separated status filter (ACTIVE, INACTIVE, UPCOMING). If not provided, returns all contacts.
     * @param search Search term to filter by firstname, lastname, email, or contact_internal_id
     * @param sortBy Column to sort by (firstname, lastname, email, status, created_at)
     * @param sortOrder Sort direction (asc, desc)
     * @param parentsOnly Filter to only show contacts who are parents (have PARENT relationship to a child)
     * @param withContracts Filter to only show contacts linked to children with current or future contracts
     * @param matchChildren Also match the search against the firstname, lastname and child number of linked children, and return each contact's children (admin parent picker)
     * @returns contacts_ContactListResponse List of contacts with pagination metadata
     * @throws ApiError
     */
    public static getApiV1Contacts(
        limit: number = 50,
        offset?: number,
        status?: string,
        search?: string,
        sortBy: string = 'lastname',
        sortOrder: string = 'asc',
        parentsOnly: boolean = false,
        withContracts: boolean = false,
        matchChildren: boolean = false,
    ): CancelablePromise<contacts_ContactListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contacts',
            query: {
                'limit': limit,
                'offset': offset,
                'status': status,
                'search': search,
                'sort_by': sortBy,
                'sort_order': sortOrder,
                'parents_only': parentsOnly,
                'with_contracts': withContracts,
                'match_children': matchChildren,
            },
            errors: {
                400: `Invalid status value or sort parameter`,
                401: `Authentication required or invalid credentials`,
                403: `Forbidden - Org ID missing or user not authorized`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Create a new contact
     * Create a new contact with personal information, address, and customer relationships
     * @param contact Contact data including personal information and optional address
     * @returns models_Contact Created contact with generated ID
     * @throws ApiError
     */
    public static postApiV1Contacts(
        contact: contacts_CreateContactRequest,
    ): CancelablePromise<models_Contact> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contacts',
            body: contact,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                409: `Email address already exists`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a contact
     * Soft delete a contact (marks as deleted but retains data for audit purposes)
     * @param id Contact ID (UUID format)
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Contacts(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/contacts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing contact ID`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Contact not found`,
                409: `Contact still has an active login (CONTACT_HAS_ACTIVE_LOGIN)`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get a contact by ID
     * Get detailed information about a single contact including address data
     * @param id Contact ID (UUID format)
     * @returns models_Contact Contact details with address
     * @throws ApiError
     */
    public static getApiV1Contacts1(
        id: string,
    ): CancelablePromise<models_Contact> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contacts/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing contact ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization/User not authorized`,
                404: `Contact not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update a contact
     * Update an existing contact with partial updates - only provided fields will be updated
     * @param id Contact ID (UUID format)
     * @param contact Updated contact data - only provided fields will be updated
     * @returns models_Contact Updated contact details
     * @throws ApiError
     */
    public static patchApiV1Contacts(
        id: string,
        contact: contacts_UpdateContactRequest,
    ): CancelablePromise<models_Contact> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/contacts/{id}',
            path: {
                'id': id,
            },
            body: contact,
            errors: {
                400: `Validation errors, invalid request format, or missing contact ID`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Contact not found`,
                409: `Email address already exists`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get contact audit history
     * Retrieve the complete audit trail for a specific contact including all changes made over time
     * @param id Contact ID (UUID format)
     * @param limit Maximum number of audit entries to return
     * @param offset Number of audit entries to skip
     * @returns contacts_ContactAuditResponse Audit history with pagination metadata
     * @throws ApiError
     */
    public static getApiV1ContactsAudit(
        id: string,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<contacts_ContactAuditResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contacts/{id}/audit',
            path: {
                'id': id,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid or missing contact ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update contact customer score
     * Update the customer score of a contact (0-100 scale for customer quality/priority)
     * @param id Contact ID (UUID format)
     * @param score New customer score (0-100)
     * @returns void
     * @throws ApiError
     */
    public static patchApiV1ContactsCustomerScore(
        id: string,
        score: contacts_UpdateContactCustomerScoreRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/contacts/{id}/customer-score',
            path: {
                'id': id,
            },
            body: score,
            errors: {
                400: `Validation errors, invalid request format, or missing contact ID`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Contact not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Link an existing Clerk user to a parent contact
     * Link the Clerk user found by the contact's main email and ensure an org:member membership. No password is returned. Admin only.
     * @param id Contact ID
     * @returns contacts_LinkContactLoginResponse OK
     * @throws ApiError
     */
    public static postApiV1ContactsLinkLogin(
        id: string,
    ): CancelablePromise<contacts_LinkContactLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contacts/{id}/link-login',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid contact ID`,
                401: `Authentication required (or user context missing)`,
                403: `Admin access required, impersonated request, or organization context missing`,
                404: `Contact not found (CONTACT_NOT_FOUND)`,
                409: `Login already linked, Clerk user taken by another contact (CONTACT_LOGIN_CLERK_USER_TAKEN), or shared with another organisation or role (CONTACT_LOGIN_SHARED_ACCOUNT)`,
                422: `No valid main email or not a parent`,
                429: `Rate limit exceeded`,
                500: `Failed to link login`,
                502: `No Clerk user for this email or Clerk request failed`,
                503: `Login provisioning not configured (CLERK_NOT_CONFIGURED)`,
            },
        });
    }
    /**
     * Get a parent contact's login status
     * Return whether the contact has a login and a best-effort "signed in" flag from one Clerk lookup. Admin only.
     * @param id Contact ID
     * @returns contacts_ContactLoginStatusResponse OK
     * @throws ApiError
     */
    public static getApiV1ContactsLoginStatus(
        id: string,
    ): CancelablePromise<contacts_ContactLoginStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contacts/{id}/login-status',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid contact ID`,
                401: `Authentication required`,
                403: `Admin access required, impersonated request, or organization context missing`,
                404: `Contact not found (CONTACT_NOT_FOUND)`,
                429: `Rate limit exceeded`,
                500: `Failed to get login status`,
            },
        });
    }
    /**
     * Create a parent login for a contact
     * Create a Clerk login (org:member) for a parent contact from its main email and return a one-time password, shown exactly once. The contact must be a parent of at least one child. Admin only.
     * @param id Contact ID
     * @returns contacts_ProvisionContactLoginResponse OK
     * @throws ApiError
     */
    public static postApiV1ContactsProvisionLogin(
        id: string,
    ): CancelablePromise<contacts_ProvisionContactLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contacts/{id}/provision-login',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid contact ID`,
                401: `Authentication required (or user context missing)`,
                403: `Admin access required, impersonated request, or organization context missing`,
                404: `Contact not found (CONTACT_NOT_FOUND)`,
                409: `Login already linked, Clerk user exists (CONTACT_LOGIN_CLERK_USER_EXISTS), or member limit reached`,
                422: `No valid main email (CONTACT_LOGIN_EMAIL_REQUIRED) or not a parent (CONTACT_LOGIN_NOT_A_PARENT)`,
                429: `Rate limit exceeded`,
                500: `Failed to provision login`,
                502: `Login provisioning failed (CONTACT_LOGIN_PROVISION_FAILED)`,
                503: `Login provisioning not configured (CLERK_NOT_CONFIGURED)`,
            },
        });
    }
    /**
     * Re-issue a parent login password
     * Set a fresh one-time password on the contact's linked Clerk user, returned exactly once. A 409 CONTACT_LOGIN_CONCURRENT_MODIFICATION means the login was revoked meanwhile and no password is returned. Admin only.
     * @param id Contact ID
     * @returns contacts_ReissueContactLoginResponse OK
     * @throws ApiError
     */
    public static postApiV1ContactsReissueLogin(
        id: string,
    ): CancelablePromise<contacts_ReissueContactLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contacts/{id}/reissue-login',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid contact ID`,
                401: `Authentication required (or user context missing)`,
                403: `Admin access required, impersonated request, or organization context missing`,
                404: `Contact not found (CONTACT_NOT_FOUND)`,
                409: `No login (CONTACT_LOGIN_NOT_LINKED), changed concurrently (CONTACT_LOGIN_CONCURRENT_MODIFICATION), or not owned by this organisation (CONTACT_LOGIN_SHARED_ACCOUNT)`,
                422: `Not a parent (CONTACT_LOGIN_NOT_A_PARENT)`,
                429: `Rate limit exceeded`,
                500: `Failed to re-issue login`,
                502: `Clerk request failed`,
                503: `Login provisioning not configured (CLERK_NOT_CONFIGURED)`,
            },
        });
    }
    /**
     * Revoke a parent login
     * Delete the parent's Clerk organization membership and clear the contact's login link. The Clerk user is never deleted. When a live employee in the organization shares the Clerk user, the membership is kept for the staff login and status reads "Login unlinked, staff login kept". When the membership role is not org:member (an admin who is also a parent), the membership is kept and status reads "Login unlinked, admin access kept". You cannot revoke your own login. Admin only.
     * @param id Contact ID
     * @returns contacts_RevokeContactLoginResponse OK
     * @throws ApiError
     */
    public static postApiV1ContactsRevokeLogin(
        id: string,
    ): CancelablePromise<contacts_RevokeContactLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contacts/{id}/revoke-login',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid contact ID`,
                401: `Authentication required (or user context missing)`,
                403: `Admin access required, impersonated request, own login (CONTACT_LOGIN_CANNOT_REVOKE_SELF), or organization context missing`,
                404: `Contact not found (CONTACT_NOT_FOUND)`,
                409: `No login (CONTACT_LOGIN_NOT_LINKED) or changed concurrently (CONTACT_LOGIN_CONCURRENT_MODIFICATION)`,
                429: `Rate limit exceeded`,
                500: `Failed to revoke login`,
                502: `Clerk request failed`,
                503: `Login provisioning not configured (CLERK_NOT_CONFIGURED)`,
            },
        });
    }
    /**
     * Update contact status
     * Update the status of a contact (ACTIVE, INACTIVE, or UPCOMING)
     * @param id Contact ID (UUID format)
     * @param status New status value
     * @returns models_Contact Updated contact with new status
     * @throws ApiError
     */
    public static patchApiV1ContactsStatus(
        id: string,
        status: contacts_UpdateContactStatusRequest,
    ): CancelablePromise<models_Contact> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/contacts/{id}/status',
            path: {
                'id': id,
            },
            body: status,
            errors: {
                400: `Validation errors, invalid request format, or missing contact ID`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Contact not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get a contact by internal ID
     * Get a single contact using the organization's internal identification number
     * @param internalId Contact Internal ID (organization-specific identifier)
     * @returns models_Contact Contact details
     * @throws ApiError
     */
    public static getApiV1ContactsByInternalId(
        internalId: string,
    ): CancelablePromise<models_Contact> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contacts/by-internal-id/{internalId}',
            path: {
                'internalId': internalId,
            },
            errors: {
                400: `Invalid or missing internal ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization/User not authorized`,
                404: `Contact not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get contact counts
     * Get statistical counts for contacts grouped by status (total, active, inactive, upcoming)
     * @returns contacts_ContactCountsResponse Contact statistics by status
     * @throws ApiError
     */
    public static getApiV1ContactsCounts(): CancelablePromise<contacts_ContactCountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contacts/counts',
            errors: {
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Export contacts to CSV
     * Export contacts to a downloadable CSV file with optional filtering by status or specific contact IDs
     * @param status Filter by contact status
     * @param ids Specific contact IDs to export (comma-separated for multiple values)
     * @returns binary CSV file download
     * @throws ApiError
     */
    public static getApiV1ContactsExportCsv(
        status?: 'ACTIVE' | 'INACTIVE' | 'UPCOMING',
        ids?: Array<string>,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contacts/export/csv',
            query: {
                'status': status,
                'ids': ids,
            },
            errors: {
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Export contacts as vCard phone book
     * Returns a .vcf file (vCard 3.0, UTF-8) with one card per contact-child pair and one card per child of the given contacts, for import into phone address books.
     * @param request Contact IDs to export
     * @returns binary vCard file download
     * @throws ApiError
     */
    public static postApiV1ContactsExportVcf(
        request: contacts_ExportContactsVCardRequest,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contacts/export/vcf',
            body: request,
            errors: {
                400: `Invalid request body or too many IDs`,
                401: `Authentication required or invalid credentials`,
                403: `Families-contacts module required, or organization ID not found in token`,
                500: `Internal server error`,
                503: `vCard export not configured`,
            },
        });
    }
    /**
     * Search contacts
     * Search for contacts using a text query that matches against name, email, or internal ID
     * @param q Search query
     * @param limit Maximum number of items to return
     * @param offset Number of items to skip
     * @returns contacts_ContactListResponse Search results with pagination metadata
     * @throws ApiError
     */
    public static getApiV1ContactsSearch(
        q: string,
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<contacts_ContactListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/contacts/search',
            query: {
                'q': q,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Missing or invalid search query`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Internal server error`,
            },
        });
    }
}
